/* eslint-disable no-useless-escape, react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Modal, Button, Uploader } from 'rsuite';
import { alert } from '../../../helpers/rsuite/Alerts';
import { getStoreByStorage } from '../../../helpers';
import { cuotitasStoreService } from '../../../services';

const uploaderStyles = {
    backgroundColor: 'hsl(240, 23%, 95%)',
    padding: '.75rem 1rem',
    border: '2px dashed hsl(240, 11%, 50%)',
    borderRadius: '10px',
    cursor: 'pointer',
    textAlign: 'center'
};

export function UploadBillDialog ({ loan, show, onHide, fetchCards, tab }) {
    const store = getStoreByStorage();

    const maxFileSizeInMB = 1000000;

    const [filelist, setFilelist] = useState([]);
    const [filesToDelete, setFilesToDelete] = useState([]);
    const [filesToUpload, setFilesToUpload] = useState([]);

    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    async function uploadBill () {
        if (filesToUpload.length === 0 && filesToDelete.length === 0) {
            return alert('warning', 'Debe cargar al menos un archivo');
        }
        try {
            setIsLoading(true);

            const data = new FormData();

            data.append('tab', tab);

            if (filesToUpload.length) {
                filesToUpload.forEach((file, index) => {
                    data.append(`bill${index}`, file.blobFile);
                });
            }

            if (filesToDelete) {
                filesToDelete.forEach((file, index) => {
                    data.append(`remove[${index}]`, file);
                });
            }

            await cuotitasStoreService.uploadLoanBill(store.id, loan.id, data);

            alert('success', 'La información se guardo correctamente.');
        }
        catch (error) {
            alert('error', 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.');
        }
        finally {
            setIsLoading(false);
            handleHide();
            fetchCards();
        }
    };

    function handleHide () {
        setFilesToUpload([]);
        setFilesToDelete([]);
        setFilelist([]);
        onHide();
    };

    function handleRemove (file) {
        if (!file.id) {
            setFilesToUpload(filesToUpload.filter(f => f.name !== file.name));
            setIsDisabled(false);
            return;
        }
        setFilesToDelete([...filesToDelete, file.id]);
        setIsDisabled(false);
    };

    function handleDownload (file) {
        const a = document.createElement('a');
        a.setAttribute('hidden', '');
        a.setAttribute('href', file.url.replace('http://', 'https://'));
        a.setAttribute('target', '_blank');
        a.setAttribute('download', `${file.name}`);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    function handleChange (files) {
        if (!files.length) return;

        const file = files[files.length - 1].blobFile;

        if (file && file.size > maxFileSizeInMB) {
            alert('error', 'El archivo seleccionado sobrepasa el máximo permitido (1MB), por favor elimínelo y elija otro.');
            setIsDisabled(true);
            return;
        }

        if (files.length > 10) {
            alert('error', 'El máximo de archivos a subir es 10.');
            return;
        }

        setFilesToUpload(files.filter(file => file.blobFile));
        setFilelist(files);
    };

    useEffect(() => {
        const files = loan?.request_files || [];
        setFilelist(files.map(file => {
            return {
                name: file.file.metadata.filename,
                fileKey: file.file.id,
                url: file.file.description,
                id: file.id,
            };
        }));
    }, []);

    return (
        <Modal open={show} onClose={onHide} className={`${show ? 'show in' : ''}`} aria-labelledby="user-create-modal" size="xs">
            <Modal.Header closeButton>
                <Modal.Title id="bill-upload-modal">
                    {isLoading && <span>Cargando Factura...</span>}
                    {!isLoading && <span>#{loan.id} Cargar Factura</span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-1">
                {!isLoading && (
                    <Uploader
                        fileList={filelist}
                        appearance="primary"
                        multiple={false}
                        accept=".doc,.docx,.pdf,.jpeg,.jpg"
                        autoUpload={false}
                        action=""
                        onChange={file => handleChange(file)}
                        onRemove={file => handleRemove(file)}
                        onPreview={file => handleDownload(file)}
                        disabled={isLoading || filelist?.length >= 10 || isDisabled}
                    >
                        <div style={uploaderStyles}>
                            Seleccionar Archivo
                        </div>
                    </Uploader>
                )}
            </Modal.Body>
            <Modal.Footer className="mt-4">
                <Button appearance="primary" loading={isLoading} disabled={isDisabled} onClick={uploadBill} id='loadBill_btn'>
                    Cargar
                </Button>
                <Button appearance="subtle" disabled={isLoading} onClick={handleHide} id='cancel_loadBill'>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
